import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { ClaimItem } from '../model/claim-item';
import { ClaimDetailsItem } from '../model/claimdetails';
import { CliemAddItem } from '../model/client-add';
import { CoverageItem } from '../model/coverage-item';
import { DeviceItem } from '../model/device-item';
import { DocumentItem } from '../model/document-item';
import { QuestionSetItem } from '../model/questionset-item';
import { RegisterItem } from '../model/register-item';
import { ShippingItem } from '../model/shipping-item';
import { DecodeToken } from '../model/decode-token-item';

@Injectable({
  providedIn: 'root'
})
export class MSSPService {

  constructor(
    private http: HttpClient
  ) { }

  //Obtiene información básica de la póliza buscando por número de poliza
  getPolicy(policy: string, idClient: string, certificate: string, multiple: boolean, dealerCode: string, responseType: string): Observable<any> {
    const params = new HttpParams()
      .set('client', idClient)
      .set('policy', policy)
      .set('certificate', certificate)
      .set('multiple', multiple)
      .set('dealerCode', dealerCode)
      .set('responseType', responseType)
    return this.http.get(`${environment.SOCKET_ENDPOINT}/api/elita/getPolicy`, { params: params });
  }

  //Obtiene detalles de la poliza por idCliente y certificateNumber
  getDetails(idClient: string, certificateNumber: string, dealerCode: string, serialnumber: string, policy: string): Observable<any> {
    const params = new HttpParams()
      .set('client', idClient)
      .set('certificate', certificateNumber)
      .set('serialnumber', serialnumber)
      .set('dealercode', dealerCode)
      .set('policy', policy)
    return this.http.get(`${environment.SOCKET_ENDPOINT}/api/elita/getDetails`, { params: params });
  }


  // Obtiene el nombre del cliente, apikey, token por dealer code
  getClientInfo(dealerCode: string): Observable<any> {
    const params = new HttpParams()
      .set('dealerCode', dealerCode)
    return this.http.get(`${environment.SOCKET_ENDPOINT}/api/elita/getClientInfo`, { params: params })
  }

  registerItem(registerItem: RegisterItem): Observable<any> {

    return this.http.post(`${environment.SOCKET_ENDPOINT}/api/elita/registerItem`, registerItem);

  }

  beginClaim(claimItem: ClaimItem, ipAddress: string): Observable<any> {
    claimItem.ClientIpAddress = ipAddress
    return this.http.post(`${environment.SOCKET_ENDPOINT}/api/elita/beginClaim`, claimItem);
  }

  productService(): Observable<any> {
    return this.http.get(`${environment.SOCKET_ENDPOINT}/api/elita/productService`)
  }

  attachDocument(msspItem: DocumentItem): Observable<any> {
    return this.http.post(`${environment.SOCKET_ENDPOINT}/api/elita/attachDocument`, msspItem);
  }

  submitShipping(msspItem: ShippingItem): Observable<any> {
    return this.http.post(`${environment.SOCKET_ENDPOINT}/api/elita/submitShipping`, msspItem);
  }

  submitQuestionSet(msspItem: QuestionSetItem): Observable<any> {
    return this.http.post(`${environment.SOCKET_ENDPOINT}/api/elita/submitQuestionSet`, msspItem)
  }

  getClaimDetails(msspItem: ClaimDetailsItem): Observable<any> {
    return this.http.post(`${environment.SOCKET_ENDPOINT}/api/elita/getClaimDetails`, msspItem);
  }

  getSearchClaim(policy: string, dealercode: string, idClient: string,): Observable<any> {
    return this.http.get(`${environment.SOCKET_ENDPOINT}/api/elita/getSearchClaim/${policy}/${dealercode}/${idClient}`);
  }

  deviceSelection(msspItem: DeviceItem): Observable<any> {
    return this.http.post(`${environment.SOCKET_ENDPOINT}/api/elita/deviceSelection`, msspItem);
  }

  getLanguajes(cliente: string): Observable<any> {
    return this.http.post(`${environment.SOCKET_ENDPOINT}/api/elita/Idioms`, cliente);
  }

  LoginAdmin(usr: string, password: string): Observable<any> {
    return this.http.get(`${environment.SOCKET_ENDPOINT}/api/elita/LoginAdmin/${usr}/${password}`);
  }

  GetAllDealerCodeByClient(idClient: string, parameterName: 'ContactUs' | 'DealerCode' | 'DownloadCertificate' | 'FrequentlyAskedQuestions' | 'IdCliente' | 'IdDealerCode' | 'IdDealerCode' | 'TerminosDeGarantia' | 'TerminosDeUso' | 'TextSurvey' | 'ServiceOption'  | 'ExternalURL'| 'VariablesBusquedaNS'| 'MultipleBusquedaNS'| 'DealerGroup' | 'CompanyCode'): Observable<any> {
    const params = new HttpParams()
      .set('client', idClient)
      .set('parameterName', parameterName)
    return this.http.get(`${environment.SOCKET_ENDPOINT}/api/elita/GetAllDealerCode`, { params: params });
  }

  DecodeToken(msspItem: DecodeToken): Observable<any> {
    return this.http.post(`${environment.SOCKET_ENDPOINT}/api/elita/DecodeToken`, msspItem);
  }

  getDataFromZipCode(zipCode: string): Observable<any> {
    return this.http.get(`${environment.SOCKET_ENDPOINT}/api/externalService/getDataFromZipCode/?zipCode=${zipCode}`);
  }

  generateLink(data:any){
    return this.http.post(`${environment.SOCKET_ENDPOINT}/api`,data);
  }

}
